/**
 * @fileoverview gRPC-Web generated client stub for reorgpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../../google/type/date_pb.js')

var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js')
const proto = {};
proto.reorgpb = require('./dividend_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reorgpb.DividendServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reorgpb.DividendServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reorgpb.ListDividendRequest,
 *   !proto.reorgpb.ListDividendResponse>}
 */
const methodDescriptor_DividendService_ListDividend = new grpc.web.MethodDescriptor(
  '/reorgpb.DividendService/ListDividend',
  grpc.web.MethodType.UNARY,
  proto.reorgpb.ListDividendRequest,
  proto.reorgpb.ListDividendResponse,
  /**
   * @param {!proto.reorgpb.ListDividendRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.ListDividendResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reorgpb.ListDividendRequest,
 *   !proto.reorgpb.ListDividendResponse>}
 */
const methodInfo_DividendService_ListDividend = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reorgpb.ListDividendResponse,
  /**
   * @param {!proto.reorgpb.ListDividendRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.ListDividendResponse.deserializeBinary
);


/**
 * @param {!proto.reorgpb.ListDividendRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reorgpb.ListDividendResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reorgpb.ListDividendResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reorgpb.DividendServiceClient.prototype.listDividend =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reorgpb.DividendService/ListDividend',
      request,
      metadata || {},
      methodDescriptor_DividendService_ListDividend,
      callback);
};


/**
 * @param {!proto.reorgpb.ListDividendRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reorgpb.ListDividendResponse>}
 *     Promise that resolves to the response
 */
proto.reorgpb.DividendServicePromiseClient.prototype.listDividend =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reorgpb.DividendService/ListDividend',
      request,
      metadata || {},
      methodDescriptor_DividendService_ListDividend);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reorgpb.Dividend,
 *   !proto.reorgpb.CreateDividendResponse>}
 */
const methodDescriptor_DividendService_CreateDividend = new grpc.web.MethodDescriptor(
  '/reorgpb.DividendService/CreateDividend',
  grpc.web.MethodType.UNARY,
  proto.reorgpb.Dividend,
  proto.reorgpb.CreateDividendResponse,
  /**
   * @param {!proto.reorgpb.Dividend} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.CreateDividendResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reorgpb.Dividend,
 *   !proto.reorgpb.CreateDividendResponse>}
 */
const methodInfo_DividendService_CreateDividend = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reorgpb.CreateDividendResponse,
  /**
   * @param {!proto.reorgpb.Dividend} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.CreateDividendResponse.deserializeBinary
);


/**
 * @param {!proto.reorgpb.Dividend} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reorgpb.CreateDividendResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reorgpb.CreateDividendResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reorgpb.DividendServiceClient.prototype.createDividend =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reorgpb.DividendService/CreateDividend',
      request,
      metadata || {},
      methodDescriptor_DividendService_CreateDividend,
      callback);
};


/**
 * @param {!proto.reorgpb.Dividend} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reorgpb.CreateDividendResponse>}
 *     Promise that resolves to the response
 */
proto.reorgpb.DividendServicePromiseClient.prototype.createDividend =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reorgpb.DividendService/CreateDividend',
      request,
      metadata || {},
      methodDescriptor_DividendService_CreateDividend);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reorgpb.Dividend,
 *   !proto.reorgpb.UpdateDividendResponse>}
 */
const methodDescriptor_DividendService_UpdateDividend = new grpc.web.MethodDescriptor(
  '/reorgpb.DividendService/UpdateDividend',
  grpc.web.MethodType.UNARY,
  proto.reorgpb.Dividend,
  proto.reorgpb.UpdateDividendResponse,
  /**
   * @param {!proto.reorgpb.Dividend} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.UpdateDividendResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reorgpb.Dividend,
 *   !proto.reorgpb.UpdateDividendResponse>}
 */
const methodInfo_DividendService_UpdateDividend = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reorgpb.UpdateDividendResponse,
  /**
   * @param {!proto.reorgpb.Dividend} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.UpdateDividendResponse.deserializeBinary
);


/**
 * @param {!proto.reorgpb.Dividend} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reorgpb.UpdateDividendResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reorgpb.UpdateDividendResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reorgpb.DividendServiceClient.prototype.updateDividend =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reorgpb.DividendService/UpdateDividend',
      request,
      metadata || {},
      methodDescriptor_DividendService_UpdateDividend,
      callback);
};


/**
 * @param {!proto.reorgpb.Dividend} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reorgpb.UpdateDividendResponse>}
 *     Promise that resolves to the response
 */
proto.reorgpb.DividendServicePromiseClient.prototype.updateDividend =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reorgpb.DividendService/UpdateDividend',
      request,
      metadata || {},
      methodDescriptor_DividendService_UpdateDividend);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reorgpb.Dividend,
 *   !proto.reorgpb.DeleteDividendResponse>}
 */
const methodDescriptor_DividendService_DeleteDividend = new grpc.web.MethodDescriptor(
  '/reorgpb.DividendService/DeleteDividend',
  grpc.web.MethodType.UNARY,
  proto.reorgpb.Dividend,
  proto.reorgpb.DeleteDividendResponse,
  /**
   * @param {!proto.reorgpb.Dividend} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.DeleteDividendResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reorgpb.Dividend,
 *   !proto.reorgpb.DeleteDividendResponse>}
 */
const methodInfo_DividendService_DeleteDividend = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reorgpb.DeleteDividendResponse,
  /**
   * @param {!proto.reorgpb.Dividend} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.DeleteDividendResponse.deserializeBinary
);


/**
 * @param {!proto.reorgpb.Dividend} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reorgpb.DeleteDividendResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reorgpb.DeleteDividendResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reorgpb.DividendServiceClient.prototype.deleteDividend =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reorgpb.DividendService/DeleteDividend',
      request,
      metadata || {},
      methodDescriptor_DividendService_DeleteDividend,
      callback);
};


/**
 * @param {!proto.reorgpb.Dividend} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reorgpb.DeleteDividendResponse>}
 *     Promise that resolves to the response
 */
proto.reorgpb.DividendServicePromiseClient.prototype.deleteDividend =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reorgpb.DividendService/DeleteDividend',
      request,
      metadata || {},
      methodDescriptor_DividendService_DeleteDividend);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reorgpb.ListDividendRequest,
 *   !proto.reorgpb.ListDividendResponse>}
 */
const methodDescriptor_DividendService_MovePageDividend = new grpc.web.MethodDescriptor(
  '/reorgpb.DividendService/MovePageDividend',
  grpc.web.MethodType.UNARY,
  proto.reorgpb.ListDividendRequest,
  proto.reorgpb.ListDividendResponse,
  /**
   * @param {!proto.reorgpb.ListDividendRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.ListDividendResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reorgpb.ListDividendRequest,
 *   !proto.reorgpb.ListDividendResponse>}
 */
const methodInfo_DividendService_MovePageDividend = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reorgpb.ListDividendResponse,
  /**
   * @param {!proto.reorgpb.ListDividendRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.ListDividendResponse.deserializeBinary
);


/**
 * @param {!proto.reorgpb.ListDividendRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reorgpb.ListDividendResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reorgpb.ListDividendResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reorgpb.DividendServiceClient.prototype.movePageDividend =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reorgpb.DividendService/MovePageDividend',
      request,
      metadata || {},
      methodDescriptor_DividendService_MovePageDividend,
      callback);
};


/**
 * @param {!proto.reorgpb.ListDividendRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reorgpb.ListDividendResponse>}
 *     Promise that resolves to the response
 */
proto.reorgpb.DividendServicePromiseClient.prototype.movePageDividend =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reorgpb.DividendService/MovePageDividend',
      request,
      metadata || {},
      methodDescriptor_DividendService_MovePageDividend);
};


module.exports = proto.reorgpb;

